require('./brokerWarrantsSellView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCover } = require('commonsComponents/OKCover');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKButton } = require('components/commons/OKButton/OKButton');
const PassContainer = require('components/contactCenter/passContainer/passContainer');

// @ components
const { BrokerWarrantsHeader } = require('components/broker/brokerProductHeaders/brokerWarrantsHeader/brokerWarrantsHeader');
const {
    BrokerWarrantsSellStep1
} = require('components/broker/brokerWarrantsSell/brokerWarrantsSellStep1/brokerWarrantsSellStep1');
const BrokerWarrantsSellStep2 = require('components/broker/brokerWarrantsSell/brokerWarrantsSellStep2/brokerWarrantsSellStep2');
const BrokerWarrantsSellSuccess = require('components/broker/brokerWarrantsSell/brokerWarrantsSellSuccess/brokerWarrantsSellSuccess');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @ actions
const BrokerWarrantsSellActions = require('actions/brokerWarrantsSell');
const WarrantFileActions = require('actions/brokerGetWarrantFile.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const profileActions = require('actions/profile');

//@ContactCenter
const BrokerLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/brokerLegalConfirmation');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

//@utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');

// @ constants
const {
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    CONTENT_TYPE_PDF,
    WIZARD_FIRST_STEP,
    FIRST_STEP,
    BROKER_SELL_SCREEN
} = require('constants/index');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');
// @Contact Center
const withContactCenterValidation = require('utilities/withContactCenterValidation');
const WebappRender = require('components/conditionalRender/webappRender')

class BrokerWarrantsSellView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayWizard: !__CONTACT_CENTER__,
            selectedValue: SELECTED_VALUES.EMPTY
        };
        this.getProductDetails = this.getProductDetails.bind(this);
        this.handleDisplayWizard = this.handleDisplayWizard.bind(this);
        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
        this.handleDisclaimerClick = this.handleDisclaimerClick.bind(this);
        this.buildDisplayWizardButton = this.buildDisplayWizardButton.bind(this);
        this.buildEmailConfirmationContent = this.buildEmailConfirmationContent.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.getCatalogueDetails = this.getCatalogueDetails.bind(this);
    }

    componentDidMount() {
        this.getProductDetails();
        this.props.fetchOpenTraderLink();
        this.getCatalogueDetails();
        scrollToTop();
        this.props.sellWarrantsTransactionCostFun(this.props.match.params.isin, this.props.history);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    onCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    getBreadcrumbData(productFile, isin, iso) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/warrantsProductFile/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerStocksSell'),
                url: ''
            }
        ];
    }

    getProductDetails() {
        const { getWarrantDetails, match: { params: { isin, iso } } } = this.props;
        getWarrantDetails(isin, iso, BROKER_SELL_SCREEN);
    }

    getCatalogueDetails() {
        this.props.getWarrantCatalogueDetails(this.props.match.params.isin);
    }

    buildSuccessful() {
        const { immBrokerWarrantsSell, immStocksContracts, productFile } = this.props;

        return (
            <div className="broker-warrants-sell-view__success col-lg-12">
                <BrokerWarrantsSellSuccess
                    productFile={productFile}
                    immBrokerWarrantsSell={immBrokerWarrantsSell}
                    immStocksContracts={immStocksContracts}
                />
            </div>
        );
    }

    handleYesNoOptionChange(value) {
        this.setState({
            selectedValue: value
        });
    }

    handleDisclaimerClick() {
        const dataBlock = this.props.immBrokerWarrantsSell.get('sellWarrantsTransactionCostBase64Data');
        const dataID = this.props.immBrokerWarrantsSell.get('sellWarrantsTransactionCostObjectId');
        if (dataBlock && dataID) {
            const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
            downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
        }
    }

    handleDisplayWizard() {
        this.setState({
            displayWizard: true,
        })
    }

    buildLinkButton(label, handleClick) {
        return (
            <OKButton
                modifier="link-inline"
                onClick={handleClick}
            >
                <span className="ok-link">{label}</span>
            </OKButton>
        );
    }

    buildLegalTextProductDescription() {
        const warrantName = this.props.productFile.get('companyName');

        return (
            <div>
                <p>{formatText("warrantsSell-firstWarrantsSellFeature", [warrantName])}</p>
            </div>
        )
    }

    buildLegalTextMandatoryReading() {
        const label = formatText(`warrantsSell-costsAndAssociatedExpensesReportLabelLink`);
        const costsAndAssociatedExpensesReportLabelLink = this.buildLinkButton(label, this.handleDisclaimerClick);

        const willSendMailSection = __CONTACT_CENTER__ ?
            (<p>{formatText("warrantsSell-legalTextMandatoryWillSendMail")}</p>) : null;

        return (
            <div>
                <FormattedTextWithComponents
                    value="warrantsSell-legalTextMandatoryReading1"
                    injectedComponents={[costsAndAssociatedExpensesReportLabelLink]}
                />
                <ul>
                    <li>{formatText("warrantsSell-legalTextMandatoryReading2")}</li>
                    <li>{formatText("warrantsSell-legalTextMandatoryReading3")}</li>
                    <li>{formatText("warrantsSell-legalTextMandatoryReading4")}</li>
                </ul>
                {willSendMailSection}
            </div>
        );
    }

    buildLegalDisclaimerQuestion() {
        const { immProfileFields } = this.props;

        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);
        const label = formatText(`warrantsSell-costsAndAssociatedExpensesReportLabelLink`);
        const costsAndAssociatedExpensesReportLabelLink = this.buildLinkButton(label, this.handleDisclaimerClick);

        return (
            <div>
                <p>{formatText("warrantsSell-legalDisclaimerQuestionFirstStatement")}</p>
                <p>
                    <FormattedTextWithComponents
                        value="warrantsSell-legalDisclaimerQuestionSecondStatement"
                        injectedComponents={[
                            costsAndAssociatedExpensesReportLabelLink
                        ]} />
                </p>
                <p>{formatText("warrantsSell-legalDisclaimerQuestionThirdStatement", [clientName])}</p>
            </div>
        );
    }

    buildDisplayWizardButton() {
        const brokerMailHasBeenSent = this.props.immBrokerWarrantsSell.get('mailSent');
        return (
            <div className="broker-warrants-sell-view__wizard-cc-button">
                <OKButton
                    onClick={this.handleDisplayWizard}
                    disabled={!brokerMailHasBeenSent}
                    modifier="secondary"
                >
                    {formatText("warrantsSell-displayWizardButtonText")}
                </OKButton>
            </div>
        );
    }

    buildEmailConfirmationContent() {
        const {
            immBrokerWarrantsSell,
            sendLeaglConfirmationMail,
            resetLeaglConfirmationMail,
            requestProfile,
            immProfileFields
        } = this.props;

        let legalConfirmationContent;
        const visibleStep = immBrokerWarrantsSell.get('visibleStep');

        const buildLegalDisclaimerYesAnswer = () => {
            return (
                <div>
                    <p>{formatText("warrantsSell-legalDisclaimerYesAnswerStatement")}</p>
                </div>
            );
        };

        const buildLegalDisclaimerNoAnswer = () => {
            const legalDisclaimerNoAnswerFirstStatement = formatText("warrantsSell-legalDisclaimerNoAnswerFirstStatement");
            const legalDisclaimerNoAnswerSecondStatement = formatText("warrantsSell-legalDisclaimerNoAnswerSecondStatement");
            return (
                <div>
                    <p>{legalDisclaimerNoAnswerFirstStatement}</p>
                    <p>{legalDisclaimerNoAnswerSecondStatement}</p>
                </div>
            );
        };


        const buildBrokerLegalConfirmation = () => {
            const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
            const refreshEmailError = immProfileFields.get('error');

            const questionSection =
                withContactCenterValidation(this.buildLegalDisclaimerQuestion(), { withNoWrapper: true })
            const productDescriptionSection =
                withContactCenterValidation(this.buildLegalTextProductDescription(), { withNoWrapper: true })
            const selectedValue = __CONTACT_CENTER__ ? SELECTED_VALUES.YES : this.state.selectedValue;

            return (
                <BrokerLegalConfirmation
                    legalDisclaimerQuestion={questionSection}
                    legalDisclaimerYesAnswer={buildLegalDisclaimerYesAnswer()}
                    legalDisclaimerNoAnswer={buildLegalDisclaimerNoAnswer()}
                    legalDisclaimerProductDescription={productDescriptionSection}
                    legalDisclaimerMandatoryReading={this.buildLegalTextMandatoryReading()}
                    onYesNoOptionChange={this.handleYesNoOptionChange}
                    selectedYesNoOption={selectedValue}
                    sendMail={sendLeaglConfirmationMail}
                    resetMailState={resetLeaglConfirmationMail}
                    clientEmailAddress={clientEmail}
                    refreshEmailAddress={requestProfile}
                    immPreContractualMail={immBrokerWarrantsSell}
                    refreshEmailAdressError={refreshEmailError}
                    sendMailParams={{ clientEmail }}
                    className={"broker-warrants-sell-view__legal-confirmation"}
                />
            );
        }

        if (__CONTACT_CENTER__ && visibleStep == WIZARD_FIRST_STEP) {
            legalConfirmationContent = (
                <div className="broker-warrants-sell-view__wizard-cc" id="printable-wizard">
                    {buildBrokerLegalConfirmation()}
                    {this.buildDisplayWizardButton()}
                </div>
            )
        }
        return legalConfirmationContent;
    }

    buildInnerWizard() {
        const {
            setVisibleStep,
            setWillCancel,
            validateStep,
            finish,
            immBrokerWarrantsSell,
            immStocksContracts,
            match: { params },
            productFile,
            immFlagBasedFeatures,
            getExAnteData,
        } = this.props;
        const immSteps = immBrokerWarrantsSell.get('steps');
        const visibleStep = immBrokerWarrantsSell.get('visibleStep');
        const actions = {
            setVisibleStep,
            validateStep,
            cancel: this.onCancel,
            setWillCancel,
            finish
        };
        const fees_url = formatText('broker-product_buy_sale_flow_see_fees_link');
        const titleHeaderMenuWizard = visibleStep === 1 ? formatText('broker-warrantsSellViewWizardTitle') : formatText('broker-warrantsSellViewWizardTitleStepTwo');
        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData: [
                {
                    label: formatText('broker-warrantsSellViewWizardSecondLinkLabel'),
                    href: fees_url,
                    hasTooltip: false,
                    target: '_blank'
                },
            ],
        };

        const productPrice = productFile.get('buyPrice');
        return (
            <Wizard
                wizardClass={'broker-warrants-sell-view__wizard no-print-out'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={immSteps.getIn([FIRST_STEP, 'loading'])}
                >
                    <BrokerWarrantsSellStep1
                        productPrice={productPrice}
                        params={params}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-warrantsSellViewFinishButtonLabel"
                    cancelButton={true}
                >
                    <BrokerWarrantsSellStep2
                        productFile={productFile}
                        immBrokerWarrantsSell={immBrokerWarrantsSell}
                        immStocksContracts={immStocksContracts}
                        sellWarrantsTransactionCostFun={this.props.sellWarrantsTransactionCostFun}
                        isinCode={this.props.match.params.isin}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        getExAnteData={getExAnteData}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildWizard() {
        const emailConfirmationContent = this.buildEmailConfirmationContent();
        return __CONTACT_CENTER__ ? (
            <div>
                {emailConfirmationContent}
                <PassContainer disable={!this.state.displayWizard}>
                    {this.buildInnerWizard()}
                </PassContainer>
            </div>
        ) : this.buildInnerWizard()
    }

    render() {
        const { immMyInvestments, immBrokerWarrantsSell, immOpenTrader, productFile, warrantFile, match: { params } } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(productFile, params.isin, params.iso);

        let contractBoxContent;
        if (productFile.get('isFetched')) {
            if (immBrokerWarrantsSell.get('submitSuccessful')) {
                contractBoxContent = this.buildSuccessful();
            } else {
                contractBoxContent = this.buildWizard();
            }
        }

        return (
            <div className="broker-warrants-sell-view">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        titleKey="broker-warrantsSellViewTitle"
                        breadcrumbConfig={mappingBreadcrumb}
                        className="broker-warrants-sell-view__header"
                    >
                        <OKButton inverse={true} modifier="ghost" to={MYPROFILE_BROKER_EXPLORE_URL}>
                            <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                        </OKButton>
                        <WebappRender>
                            <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                            </OKButton>
                        </WebappRender>
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
                <section className="broker-warrants-sell-view__body">
                    <BrokerWarrantsHeader
                        productFile={productFile}
                        warrantFile={warrantFile}
                        immMyInvestments={immMyInvestments}
                        handleUpdate={this.getProductDetails}
                        exchangeId={this.props.match.params.exchangeId}
                        spcSymbol={this.props.match.params.spcSymbol}
                        noBottomButtons={true}
                    />
                    <div className="broker-warrants-sell-view__wizard">
                        {contractBoxContent}
                    </div>
                </section>
            </div>
        );
    }
}

BrokerWarrantsSellView.propTypes = {
    productFile: PropTypes.object,
    history: PropTypes.object.isRequired,
    immBrokerWarrantsSell: PropTypes.object,
    immOpenTrader: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    reset: PropTypes.func,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    validateStep: PropTypes.func,
    finish: PropTypes.func,
    getWarrantDetails: PropTypes.func,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    match: PropTypes.object,
    handleChangeReadChecked: PropTypes.func.isRequired,
    validateCheck: PropTypes.func.isRequired,
    sellWarrantsTransactionCostFun: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    sendLeaglConfirmationMail: PropTypes.func.isRequired,
    resetLeaglConfirmationMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    getExAnteData: PropTypes.func.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    warrantFile: PropTypes.object,
};

module.exports.constructor = BrokerWarrantsSellView;
module.exports.BrokerWarrantsSellView = connect(
    state => ({
        productFile: state.brokerProductFile,
        immBrokerWarrantsSell: state.brokerWarrantsSell,
        immOpenTrader: state.brokerOpenTrader,
        immStocksContracts: state.brokerStocksContract,
        immProfileFields: state.profile,
        immMyInvestments: state.brokerMyInvestments,
        immVariables: state.globalVariables,
        immFlagBasedFeatures: state.flagBasedFeatures,
        warrantFile: state.brokerWarrantsFile,
    }),
    {
        reset: BrokerWarrantsSellActions.reset,
        setVisibleStep: BrokerWarrantsSellActions.setVisibleStep,
        setWillCancel: BrokerWarrantsSellActions.setWillCancel,
        validateStep: BrokerWarrantsSellActions.validateStep,
        finish: BrokerWarrantsSellActions.finish,
        getWarrantDetails: WarrantFileActions.getWarrantFile,
        getWarrantCatalogueDetails: WarrantFileActions.getWarrantCatalogueDetails,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        handleChangeReadChecked: BrokerWarrantsSellActions.changeReadChecked,
        getExAnteData: BrokerWarrantsSellActions.getExAnteData,
        validateCheck: BrokerWarrantsSellActions.validateCheck,
        sellWarrantsTransactionCostFun: BrokerWarrantsSellActions.fetchSellWarrantsTransactionCost,
        sendLeaglConfirmationMail: BrokerWarrantsSellActions.sendLeaglConfirmationMail,
        resetLeaglConfirmationMail: BrokerWarrantsSellActions.resetLeaglConfirmationMail,
        requestProfile: profileActions.requestProfile
    }
)(withRouter(BrokerWarrantsSellView));
